import { ArrowUpRight } from "lucide-react";
import { site } from "@/data/site";
import { Reveal } from "./Reveal";

export const PropertyFiles = () => {
    const feature = site.files.find((f) => f.feature) || site.files[0];
    const rest = site.files.filter((f) => f !== feature);

    const go = () =>
        document.querySelector("#consultation")?.scrollIntoView({
            behavior: "smooth",
        });

    return (
        <section
            id="files"
            data-testid="files-section"
            className="bg-sand px-6 py-16 lg:px-10 lg:py-24"
        >
            <div className="mx-auto max-w-[1400px]">
                <Reveal>
                    <div className="mb-12 flex flex-col justify-between gap-6 border-b border-line pb-8 lg:flex-row lg:items-end">
                        <div>
                            <span className="eyebrow">The Journal</span>
                            <h2 className="mt-5 font-serif text-4xl leading-[1.08] tracking-tight text-charcoal sm:text-5xl">
                                Mumbai Property Files
                            </h2>
                        </div>
                        <p className="max-w-sm text-base leading-relaxed text-slatey">
                            Insight, intelligence and perspective for the discerning
                            buyer — our editorial engine on Mumbai's luxury market.
                        </p>
                    </div>
                </Reveal>

                {/* Category strip */}
                <Reveal>
                    <div data-testid="files-categories" className="mb-8 flex flex-wrap gap-2.5">
                        {site.fileCategories.map((c, i) => (
                            <span
                                key={c}
                                className={`border px-4 py-2 text-[10px] uppercase tracking-[0.14em] transition-colors duration-300 ${
                                    i === 0
                                        ? "border-orange bg-orange text-white"
                                        : "border-line text-charcoal/70 hover:border-champagne hover:text-charcoal"
                                }`}
                            >
                                {c}
                            </span>
                        ))}
                    </div>
                </Reveal>

                {/* Feature */}
                <Reveal>
                    <button
                        data-testid="file-feature"
                        onClick={go}
                        className="group mb-6 grid w-full grid-cols-1 overflow-hidden border border-line bg-white text-left transition-all duration-500 hover:border-champagne hover:shadow-[0_28px_70px_rgba(43,43,43,0.1)] lg:mb-8 lg:grid-cols-2"
                    >
                        <div className="relative aspect-[16/10] overflow-hidden lg:aspect-auto">
                            <img
                                src={feature.image}
                                alt={feature.title}
                                loading="lazy"
                                className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                            />
                        </div>
                        <div className="flex flex-col justify-center p-8 lg:p-12">
                            <span className="text-[10px] uppercase tracking-luxe text-orange">
                                {feature.category}
                            </span>
                            <h3 className="mt-5 font-serif text-3xl leading-tight text-charcoal lg:text-4xl">
                                {feature.title}
                            </h3>
                            <p className="mt-5 max-w-md text-base leading-relaxed text-slatey">
                                {feature.excerpt}
                            </p>
                            <div className="mt-8 flex items-center gap-3 text-xs uppercase tracking-[0.15em] text-charcoal">
                                <span>{feature.read}</span>
                                <span className="h-px w-10 bg-champagne" />
                                <ArrowUpRight
                                    size={16}
                                    className="text-orange transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                                />
                            </div>
                        </div>
                    </button>
                </Reveal>

                {/* Grid */}
                <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-8">
                    {rest.map((f, i) => (
                        <Reveal key={f.title} delay={(i % 4) * 0.08}>
                            <button
                                data-testid={`file-card-${i}`}
                                onClick={go}
                                className="group flex h-full w-full flex-col overflow-hidden border border-line bg-white text-left transition-all duration-500 hover:-translate-y-1 hover:border-champagne hover:shadow-[0_20px_50px_rgba(43,43,43,0.08)]"
                            >
                                <div className="relative aspect-[3/2] overflow-hidden">
                                    <img
                                        src={f.image}
                                        alt={f.title}
                                        loading="lazy"
                                        className="h-full w-full object-cover transition-transform duration-[1400ms] ease-out group-hover:scale-105"
                                    />
                                </div>
                                <div className="flex flex-1 flex-col p-6">
                                    <span className="text-[10px] uppercase tracking-luxe text-orange">
                                        {f.category}
                                    </span>
                                    <h3 className="mt-3 font-serif text-xl leading-snug text-charcoal">
                                        {f.title}
                                    </h3>
                                    <span className="mt-auto pt-6 text-xs uppercase tracking-[0.15em] text-slatey">
                                        {f.read}
                                    </span>
                                </div>
                            </button>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
};
